import { HistoryOutlined, AutoFixHigh } from '@mui/icons-material'
import GenericFloatingButton from '../../../generic/buttons/floatingButtons/GenericFloatingButton'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { useTheme } from '@emotion/react'
import { Stack } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import GridOnIcon from '@mui/icons-material/GridOn'
import GridOffIcon from '@mui/icons-material/GridOff'
import SaveIcon from '@mui/icons-material/Save'
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize'

const WidgetEditionToolbar = ({ editing, setEditing, onAddClick, onRevert, onSave, showGrid, setShowGrid, onCompact, onTemplatesClick, deviceName }) => {
  const theme = useTheme()
  const { t_ } = useSmartTranslation()

  if (!editing) {
    return (
      <Stack
        direction='row-reverse' justifyContent='flex-start'
        alignItems='flex-start'
        sx={{ pointerEvents: 'none' }}
      >
        <GenericFloatingButton
          icon={<EditIcon color='warning' />}
          color={theme.palette.warning.light}
          opacity={1}
          onClick={() => { setEditing(true) }}
          disabled={false}
          sx={{ pointerEvents: 'auto' }}
        />
      </Stack>
    )
  }

  return (
    <Stack direction='row-reverse' justifyContent='space-between' sx={{ pointerEvents: 'none', zIndex: 100000 }} gap={3}>
      <Stack direction='row' gap={1} sx={{ pointerEvents: 'none' }}>
        <GenericFloatingButton
          label={showGrid ? t_('Hide grid') : t_('Show grid')}
          icon={showGrid ? <GridOffIcon /> : <GridOnIcon />}
          color={theme.palette.info.light}
          opacity={1}
          onClick={() => setShowGrid(!showGrid)}
          disabled={false}
          sx={{ pointerEvents: 'auto' }}
        />
        <GenericFloatingButton
          label={t_('Auto-organize')}
          icon={<AutoFixHigh />}
          color={theme.palette.info.light}
          opacity={1}
          onClick={onCompact}
          disabled={false}
          sx={{ pointerEvents: 'auto' }}
        />
        <GenericFloatingButton
          label={t_('Revert')}
          icon={<HistoryOutlined />}
          color={theme.palette.error.light}
          opacity={1}
          onClick={onRevert}
          disabled={false}
          sx={{ pointerEvents: 'auto' }}
        />
        <GenericFloatingButton
          label={t_('Save')}
          icon={<SaveIcon />}
          color={theme.palette.primary.light}
          opacity={1}
          onClick={onSave}
          disabled={false}
          sx={{ pointerEvents: 'auto' }}
        />
        {onTemplatesClick && (
          <GenericFloatingButton
            label={t_('Templates')}
            icon={<DashboardCustomizeIcon />}
            color={theme.palette.info.light}
            opacity={1}
            onClick={onTemplatesClick}
            disabled={false}
            sx={{ pointerEvents: 'auto' }}
          />
        )}
      </Stack>

      <GenericFloatingButton
        label={deviceName || t_('MOS - Initial Screen')}
        opacity={1}
        disabled={false}
        sx={{ pointer: 'none', flexGrow: 1 }}
      />

      <GenericFloatingButton
        label={t_('Add widget')}
        icon={<AddIcon />}
        color={theme.palette.primary.light}
        opacity={1}
        onClick={onAddClick}
        disabled={false}
        sx={{ pointerEvents: 'auto' }}
      />
    </Stack>
  )
}

export default WidgetEditionToolbar
